module.exports = __webpack_public_path__ + "img/Flags Container (1).3bf40954.png";